require('core-js/stable')
require('regenerator-runtime/runtime')

/**
 * This loads the polyfill for URL that IE11 needs, and is only avialable in newer package versions that
 * babel is not using yet.
 */
require('core-js/web/url')
